export default {
  parentNotificationTemplateList: [],
  parentNotificationTemplateInfo: null,
  currentPage: null
}
